import { apiHost } from '@libs/providers/api-host.provider';
import { HttpStatuses } from './blog.service';


const url = `${apiHost()}/web/author/`;

export function getAuthor(name: string) {
    const authorId = `${apiHost()}/web/authors/${encodeURI(name)}`;

    return fetch(authorId)
        .then(response => {
            switch (response.status) {
                case HttpStatuses.received:
                    return response.json();
                case HttpStatuses.notFound:
                    throw new Error('Not found')
                default:
                    throw new Error('Smth bad');
            }
        })
}


export function getAuthors() {
    const authorId = `${apiHost()}/web/authors/author/`;

    return fetch(authorId)
        .then(response => {
            switch (response.status) {
                case HttpStatuses.received:
                    return response.json();
                case HttpStatuses.notFound:
                    throw new Error('Not found')
                default:
                    throw new Error('Smth bad');
            }
        })
}


export function getAuthorsArticles(compact = false, skip?: number, take?: number, authorName?: string) {
    const query = new URLSearchParams({});
    if (skip) {
        query.set('skip', String(skip));
    }
    if (compact) query.set('compact', 'true');

    if (take) {
        query.set('take', String(take));
    }

    if (authorName) {
        query.set('authorName', authorName);
    }
    const finalUrl = `${apiHost()}/web/authors/articles/?${query}`;

    return fetch(finalUrl, {
        method: 'GET',
        headers: {"Content-Type": "application/json"},
    }).then(response => {
        switch (response.status) {
            case HttpStatuses.received:
                return response.json();
            case HttpStatuses.notFound:
                throw new Error('Not found')
            default:
                throw new Error('Something went wrong');
        }
    });
}
